import { render } from "./KamranLikes.vue?vue&type=template&id=0b7b0e06&scoped=true"
import script from "./KamranLikes.vue?vue&type=script&lang=js"
export * from "./KamranLikes.vue?vue&type=script&lang=js"

import "./KamranLikes.vue?vue&type=style&index=0&id=0b7b0e06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7b0e06"]])

export default __exports__